import React from 'react';

export const ContactPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">联系我们</h1>
      <p className="text-sm text-gray-500 mb-8">如有任何问题或建议，欢迎通过以下方式与我们联系</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {/* 邮箱 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 text-center">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">电子邮箱</h3>
          <a href="mailto:aikidcode@foxmail.com" className="text-blue-600 hover:underline text-sm">
            support@aikidcode.cn
          </a>
        </div>

        {/* 网站 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 text-center">
          <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
            </svg>
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">官方网站</h3>
          <a href="https://aikidcode.cn" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-sm">
            aikidcode.cn
          </a>
        </div>

        {/* 工作时间 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 text-center">
          <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">工作时间</h3>
          <p className="text-sm text-gray-600">周一至周五 9:00 - 18:00</p>
        </div>
      </div>

      {/* 常见问题 */}
      <h2 className="text-xl font-semibold text-gray-900 mb-4">常见问题</h2>
      <div className="space-y-4">
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <h3 className="font-medium text-gray-900 mb-2">如何重置密码？</h3>
          <p className="text-sm text-gray-600">
            在登录页面点击"忘记密码"，输入注册时使用的邮箱地址，按照邮件指引完成密码重置。
          </p>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <h3 className="font-medium text-gray-900 mb-2">上传的图片数据安全吗？</h3>
          <p className="text-sm text-gray-600">
            所有上传数据通过加密传输存储在服务器上，仅用于您自己的 AI 项目训练。详情请参阅
            <a href="/privacy" className="text-blue-600 hover:underline"> 隐私政策</a>。
          </p>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <h3 className="font-medium text-gray-900 mb-2">平台适合多大年龄的孩子使用？</h3>
          <p className="text-sm text-gray-600">
            本平台面向 8-16 岁青少年设计，内容难度从入门到进阶均有覆盖。建议低龄用户在家长指导下使用。
          </p>
        </div>
      </div>
    </div>
  );
};
